// Shared office data for site
export default [
  {
    id: 'hq',
    name: 'DXPRO SOLUTIONS 本社',
    address: '〒114-0014 東京都北区田端4-21-14 シャンボール大和郷 402',
    email: 'info@dxpro-sol.com',
    hours: '平日 9:00 – 18:00',
    mapEmbed:
      'https://www.google.com/maps/embed?pb=!1m18!1m12!1m3!1d6476.93680533215!2d139.75243087484!3d35.73929032678414!2m3!1f0!2f0!3f0!3m2!1i1024!2i768!4f13.1!3m3!1m2!1s0x60188deba9dc10b9%3A0x959dc904c9c6444b!2z44CSMTE0LTAwMTQg5p2x5Lqs6YO95YyX5Yy655Sw56uv77yU5LiB55uu77yS77yR4oiS77yR77yUIOaIuOaenee3j-alreOCt-ODo-ODs-ODnOODvOODq-Wkp-WSjOmDtw!5e0!3m2!1sja!2sjp!4v1722505564939!5m2!1sja!2sjp'
  },
  {
    id: 'hq',
    name: 'DXPRO SOLUTIONS 開発事務所',
    address: '準備中',
  }
];
